// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"info-tooltip_wrapper__3QaJa"};